<script setup lang="ts">
import '@/assets/styles/legal.css'
</script>

<template><div class="legal-page">
  <div class="legal-page">
    <section class="legal-hero">
      <div class="legal-hero-content">
        <span>Datenschutz</span>
        <h1>Datenschutz<wbr/>erklärung</h1>
        <p>Transparente Informationen darüber, welche Daten verarbeitet werden und wofür.</p>
      </div>

      <div class="legal-hero-panel">
        <strong>Stand: Juni 2026</strong>
        <p>Kontakt-, Projekt- und Hosting-Prozesse dieser Website.</p>
      </div>
    </section>

    <section class="legal-layout">
      <aside class="legal-aside">
        <span>Auf dieser Seite</span>
        <a href="#ueberblick">Überblick</a>
        <a href="#verantwortlicher">Verantwortlicher</a>
        <a href="#hosting">Hosting</a>
        <a href="#formulare">Formulare</a>
        <a href="#rechte">Ihre Rechte</a>
        <a href="#whatsapp">WhatsApp</a>
      </aside>

      <div class="legal-card">
        <div class="legal-note">
          <strong>Datenschutz auf einen Blick</strong>
          <p>Diese Datenschutzerklärung beschreibt die aktuell vorgesehenen Kontakt-, Projekt- und Hosting-Prozesse dieser Website.</p>
        </div>

        <h2 id="ueberblick">1. Datenschutz auf einen Blick</h2>
        <p>
          Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir behandeln Ihre personenbezogenen Daten
          vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
        </p>
        <p>
          Die Nutzung unserer Website ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren
          Seiten personenbezogene Daten erhoben werden, erfolgt dies auf freiwilliger Basis oder zur Bearbeitung Ihrer
          Anfrage.
        </p>

        <h2 id="verantwortlicher">2. Verantwortlicher</h2>
        <p>
          <strong>Butterweck Digital</strong><br/>
          Inhaber: Maximilian Butterweck<br/>
          Kriemhildenstraße 23<br/>
          65205 Wiesbaden<br/>
          Deutschland<br/>
          E-Mail: <a href="mailto:info@butterweck-digital.de">info@butterweck-digital.de</a><br/>
          Telefon: <a href="tel:+4915150784965">+49 151 50784965</a>
        </p>

        <h2 id="hosting">3. Hosting</h2>
        <p>Diese Website wird auf einem virtuellen privaten Server (VPS) bei folgendem Anbieter betrieben:</p>
        <p>
          IONOS SE<br/>
          Elgendorfer Straße 57<br/>
          56410 Montabaur<br/>
          Deutschland
        </p>
        <p>
          Der Hosting-Anbieter verarbeitet personenbezogene Daten nur insoweit, wie dies zur Erfüllung seiner
          Leistungspflichten erforderlich ist und folgt unseren Weisungen. Mit dem Anbieter besteht ein Vertrag zur
          Auftragsverarbeitung gemäß Art. 28 DSGVO.
        </p>

        <h2 id="formulare">4. Erhebung und Verarbeitung personenbezogener Daten</h2>

        <h3>a) Kontaktformular</h3>
        <p>
          Wenn Sie uns über das Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Formular inklusive
          der von Ihnen angegebenen Kontaktdaten zum Zweck der Bearbeitung gespeichert.
        </p>
        <ul>
          <li>Name</li>
          <li>E-Mail-Adresse</li>
          <li>Telefonnummer</li>
          <li>Nachricht</li>
        </ul>
        <p>
          Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung) und Art. 6 Abs. 1 lit. f DSGVO
          (berechtigtes Interesse).
        </p>

        <h3>b) Projektanfrage / Angebotsanfrage</h3>
        <p>
          Wenn Sie über unser Formular eine Projekt- oder Angebotsanfrage stellen, können zusätzlich folgende Daten
          erhoben werden:
        </p>
        <ul>
          <li>Firmenname</li>
          <li>Gewünschtes Webdesign-Paket</li>
          <li>Anzahl benötigter Seiten</li>
          <li>Designwünsche wie Farben, Logos, Texte und Bilder</li>
          <li>Weitere Projektinformationen</li>
        </ul>
        <p>
          Diese Daten dienen ausschließlich der Vorbereitung und Durchführung eines möglichen Webdesign-Projekts.
          Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung).
        </p>

        <h3>c) Datei-Uploads</h3>
        <p>
          Im Rahmen der Projektanfrage können Sie optional Dateien hochladen, zum Beispiel Logos, Bilder oder Texte.
          Diese werden ausschließlich zur Bearbeitung Ihrer Anfrage und zur Erstellung der Website genutzt.
        </p>

        <h2>5. Server-Log-Dateien</h2>
        <p>
          Der Hosting-Anbieter erhebt und speichert automatisch Informationen in Server-Log-Dateien, die Ihr Browser
          automatisch übermittelt:
        </p>
        <ul>
          <li>Browsertyp und -version</li>
          <li>Verwendetes Betriebssystem</li>
          <li>Referrer URL</li>
          <li>IP-Adresse</li>
          <li>Uhrzeit der Serveranfrage</li>
        </ul>
        <p>
          Diese Daten werden nicht mit anderen Datenquellen zusammengeführt. Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO.
        </p>

        <h2>6. SSL- / TLS-Verschlüsselung</h2>
        <p>
          Diese Website nutzt eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie an
          „https://“ in der Adresszeile. Ihre Daten werden während der Übertragung geschützt.
        </p>

        <h2>7. Speicherung und Löschung der Daten</h2>
        <p>
          Ihre personenbezogenen Daten werden nur so lange gespeichert, wie dies zur Bearbeitung Ihrer Anfrage oder zur
          Durchführung eines Projekts erforderlich ist.
        </p>
        <ul>
          <li>Kontaktanfragen: bis zur abschließenden Bearbeitung</li>
          <li>Projektanfragen: bis Abschluss oder Abbruch des Projekts</li>
        </ul>

        <h2 id="rechte">8. Ihre Rechte</h2>
        <ul>
          <li>Auskunft über gespeicherte Daten</li>
          <li>Berichtigung unrichtiger Daten</li>
          <li>Löschung oder Einschränkung der Verarbeitung</li>
          <li>Widerspruch gegen die Verarbeitung</li>
          <li>Datenübertragbarkeit</li>
        </ul>

        <h2>9. Widerruf Ihrer Einwilligung</h2>
        <p>
          Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf
          erfolgten Verarbeitung bleibt unberührt.
        </p>

        <h2>10. Beschwerderecht bei der Aufsichtsbehörde</h2>
        <p>
          Sie haben das Recht, sich bei einer Datenschutzaufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen
          Daten zu beschweren. Zuständige Behörde ist die Datenschutzbehörde Ihres Bundeslands.
        </p>

        <h2>11. Änderungen der Datenschutzerklärung</h2>
        <p>
          Wir behalten uns vor, diese Datenschutzerklärung anzupassen, um Änderungen unserer Website oder gesetzliche
          Anforderungen umzusetzen.
        </p>

        <h2 id="whatsapp">12. WhatsApp Kontakt</h2>
        <p>
          Für die Kontaktaufnahme bieten wir die Möglichkeit, über den Messenger-Dienst WhatsApp Kontakt aufzunehmen.
          Anbieter ist die WhatsApp Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland.
        </p>
        <p>
          Wenn Sie über WhatsApp Kontakt mit uns aufnehmen, werden personenbezogene Daten wie Ihre Telefonnummer,
          Nachrichteninhalte sowie weitere Kommunikationsdaten verarbeitet und an WhatsApp bzw. Meta übertragen.
        </p>
        <p>
          Die Nutzung erfolgt freiwillig und auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO sowie Art. 6 Abs. 1 lit. f DSGVO.
        </p>
        <p>
          Weitere Informationen zum Datenschutz bei WhatsApp finden Sie unter:
          <a href="https://www.whatsapp.com/legal/privacy-policy-eea" target="_blank" rel="noopener">
            https://www.whatsapp.com/legal/privacy-policy-eea
          </a>
        </p>
      </div>
    </section>
  </div>
</div></template>
